import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";

export default function RefCapture() {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    let done = false;
    (async () => {
      try {
        const { data } = await api.post(`/r/${code}/visit`);
        localStorage.setItem("tb_ref", (data.code || code).toUpperCase());
        toast.success(`Bienvenue ! Vous êtes parrainé par ${data.influencer_name}.`);
      } catch {
        // invalid code — ignore silently
      } finally {
        if (!done) navigate("/", { replace: true });
      }
    })();
    return () => { done = true; };
  }, [code, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0F172A] text-white" data-testid="ref-capture">
      <p className="text-sm text-slate-300">Redirection en cours…</p>
    </div>
  );
}
